import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RiskCardAlert, RiskCardComponent } from './risk-card/risk-card.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RiskCardComponent, NgTemplateOutlet],
  styles: [],
  templateUrl: './risk-analytics.component.html',
})
export class RiskAnalyticsComponent {
  fpAlerts: RiskCardAlert[] = [
    {
      color: 'red',
      message: 'Accrual gap is greater than 10% for >2 months',
    },
    {
      color: 'red',
      message: 'Missed trailing quarterly forecast by 10%',
    },
    {
      color: 'red',
      message: 'Deviation to original budget > 10%',
    },
  ];
  paceOfSpendAlerts: RiskCardAlert[] = [
    {
      color: 'green',
      message: 'Cash position is above $1m',
    },
    {
      color: 'green',
      message: 'All categories remain less than 80% of budget',
    },
  ];
  patientAlerts: RiskCardAlert[] = [
    {
      color: 'red',
      message: 'Average cost per patient to date exceeds budget by 20%',
    },
    {
      color: 'green',
      message: 'Forecasted average cost through EOT exceeds current budget by 20%',
    },
    {
      color: 'green',
      message: 'Projected cost at full enrollment exceeds trial budget by 20% - 3 month Trend',
    },
  ];
  siteAlerts: RiskCardAlert[] = [
    {
      color: 'red',
      message: '4 Sites with > 2 protocol deviations',
    },
    {
      color: 'red',
      message: 'Data cleaning Efficiency ratio implies cost risk of > $25k',
    },
    {
      color: 'red',
      message: '15% of sites with target site efficiency ratio < 3',
    },
  ];
  timelineAlerts: RiskCardAlert[] = [
    {
      color: 'red',
      message: 'Average site initiation time is greater than 4 months',
    },
    {
      color: 'red',
      message: 'Site visit pace lagging with budget impacts exceeding $100K',
    },
  ];
  timelineData = [
    {
      header: 'Sites Initiated',
      leftLabel: 'First Site - 11/5/19',
      progressColor: 'green',
      rightLabel: 'Last Site - 11/5/19',
      value: 100,
    },
    {
      header: 'Patient Enrollment',
      leftLabel: 'First Patient - 12/5/19',
      progressColor: 'blue',
      rightLabel: 'Last Patient - In 45 days',
      value: 50,
    },
    {
      header: 'Sites Initiated',
      leftLabel: 'Database Lock - In 73 days',
      progressColor: 'blue',
      rightLabel: 'End of Trial - In 99 days',
      value: 5,
    },
  ];
}
